import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=43585a74"
import script from "./CookiesPage.vue?vue&type=script&lang=js"
export * from "./CookiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports